import { useCallback, useState } from "react";
import { useModal } from "@ebay/nice-modal-react";
import CommonInput from "../../../../../components/ui/commonInput/CommonInput"
import CoinImg from '../../../../../assets/images/sbtc.png';
import BTC from '../../../../../assets/images/btc.png';
import { ExclamationIcon } from "../../../../../assets/svgIcons/svgIcons";
import CommonButton from "../../../../../components/common/commonButton/CommonButton";
import WalletConnect from "@walletconnect/client";
import QRCodeModal from "@walletconnect/qrcode-modal";
import CommonTooltip from "../../../../../components/ui/commonTooltip/CommonTooltip";
import {
  request,
  AddressPurpose
} from "sats-connect";

import { OKXUniversalProvider } from "@okxconnect/universal-provider";
import { Toast } from "../../../../../components/common/toast/Toast";
import { formatAddress } from "../../../../../utils/commonUtils";
import { OKXUniversalConnectUI } from "@okxconnect/ui";

declare global {
  interface Window {
    tomo_btc?: {
      requestAccounts: () => Promise<string[]>;
      // Add more methods if needed
    };
  }
}

declare global {
  interface Window {
    bitgetTonWallet?: {
      request: (options: { method: string; params?: any }) => Promise<any>;
    };
  }
}

declare global {
  interface Window {
    bitkeep?: {
      unisat: {
        requestAccounts: () => Promise<string[]>;
        getAccounts: () => Promise<string[]>;
        // Add more methods if needed
      };
    };
  }
}


const Unstake = () => {
  const ConnectBtcWalletModal = useModal("ConnectBtcWalletModal");
  const [btcAddress, setBtcAddress] = useState("");
  const [isConnected, setIsConnected] = useState(false);
  const [paymentAddress, setPaymentAddress] = useState('');
  const [ordinalsAddress, setOrdinalsAddress] = useState('');
  const [stacksAddress, setStacksAddress] = useState('');
  const [error, setError] = useState('');
  const [okxUniversalConnectUI, setOkxUniversalConnectUI] = useState<OKXUniversalConnectUI | null>(null);
  const [walletType, setWalletType] = useState<string | null>(null);
  const disconnectWallet = async (walletType: string | null) => {
    try {
      switch (walletType) {
        case "okx":
          if (okxUniversalConnectUI) {
            await okxUniversalConnectUI.disconnect();  
          }
          break;
        case "xverse":
          await request("wallet_disconnect", null);
          setPaymentAddress('');
          setIsConnected(false);
          setWalletType(null);
          Toast.success("Disconnected from wallet");
          break;
        case "tomo":
          setPaymentAddress('');
          setIsConnected(false);
          setWalletType(null);
          break;
        case "bitget":
          setPaymentAddress('');
          setIsConnected(false);
          setWalletType(null);
          break;
        default:
          console.error("Unknown wallet type");
          return;
      }
      
      // Clear the wallet state
      setPaymentAddress('');
      setIsConnected(false);
      Toast.success("Disconnected from wallet");
      
    } catch (error) {
      console.error(`Error disconnecting from ${walletType}:`, error);
    }
  };

    const connectWallet = async () => {
      try {
        const response = await request('wallet_connect', {
          addresses: ['ordinals', 'stacks'] as AddressPurpose[],
          message: 'Connect your Xverse Wallet to access Bitcoin and Stacks addresses.',
        });
  
        if (response.status === 'success') {
          const paymentAddr = response.result.addresses.find(
            (address) => address.purpose === 'payment'
          );
          const ordinalsAddr = response.result.addresses.find(
            (address) => address.purpose === 'ordinals'
          );
          const stacksAddr = response.result.addresses.find(
            (address) => address.purpose === 'stacks'
          );
  
          setPaymentAddress(paymentAddr?.address || '');
          setOrdinalsAddress(ordinalsAddr?.address || '');
          setStacksAddress(stacksAddr?.address || '');
          setWalletType('xverse')
        } else {
          if (response.error) {
            setError('Connection request was rejected by the user.');
          } else {
            Toast.error("Xverse Wallet extension not found. Please install it.");
            setError('An error occurred during the connection request.');
          }
        }
      } catch (err) {
        Toast.error("Xverse Wallet extension not found. Please install it.");
        setError('An unexpected error occurred.');
      }
    }

  const connectToOkxWallet = async () => {
  try {


    const okxUniversalConnectUI = await OKXUniversalConnectUI.init({
      dappMetaData: {
          icon: "https://static.okx.com/cdn/assets/imgs/247/58E63FEA47A2B7D7.png",
          name: "OKX Connect UI Demo"
      },
      actionsConfiguration: {
          returnStrategy: 'tg://resolve',
          modals:"all"
      },
      language: "en_US",
      uiPreferences: {
          theme: undefined
      },
  });
  setOkxUniversalConnectUI(okxUniversalConnectUI); 

  let session = await okxUniversalConnectUI.openModal({
    namespaces: {
      btc: {
        chains: ["btc:mainnet"], // Ensure the correct network
      },
    },
    sessionConfig: {
      redirect: "tg://resolve",
    },
  });

  console.log("Session Established:", session);

  const btcAccounts = session?.namespaces?.btc?.accounts;
  
  if (Array.isArray(btcAccounts) && btcAccounts.length > 0) {
    const btcAddress = btcAccounts[0]; // Get the first BTC address
    setPaymentAddress(btcAddress);
    setIsConnected(true);
    setWalletType('okx')
    console.log("Connected BTC Address:", btcAddress);
  } else {
    console.error("No Bitcoin accounts returned from OKX Wallet.");
  }
  } catch (err) {
    console.error("Error connecting to OKX Wallet:", err);
    // Handle errors (e.g., show user-friendly error messages)
    // setError(err.message || "An unexpected error occurred.");
  }
};

    
    const connectToTomoWallet = async () => {
      try {
        if (!window?.tomo_btc) {
          Toast.error("Tomo Wallet extension not found. Please install it.");
          throw new Error("Tomo Wallet extension not found. Please install it.");
        }
  
        // Request accounts from Tomo Wallet
        const accounts = await window?.tomo_btc.requestAccounts();
        console.log("JIIIIIIIIIIIIIII", window?.tomo_btc)
        const account = accounts[0];
  
        if (account) {
          setPaymentAddress(account);
          setIsConnected(true);
          setWalletType('tomo');
          console.log("Connected to Tomo Wallet:", account);
        } else {
          throw new Error("No accounts found in Tomo Wallet.");
        }
      } catch (err) {
        console.error("Error connecting to Tomo Wallet:", err);
        //setError(err.message || "An unexpected error occurred.");
      }
    };

    // Function to connect to Bitget Wallet and retrieve the BTC address
const connectToBitgetWallet = async () => {
  try {
    // Check if Bitget Wallet extension is installed
    if (window.bitkeep && window.bitkeep.unisat) {
      const unisat = window.bitkeep.unisat;
      console.log('unisat unisat:', unisat);
      // Request accounts from Bitget Wallet
      const accounts = await unisat.requestAccounts();
      console.log('Connected successfully:', accounts);

      // Retrieve the current account
      const currentAccount = await unisat.getAccounts();
      console.log('Current BTC Account:', currentAccount);

      // Set the payment address to the first account
      if (currentAccount.length > 0) {
        setPaymentAddress(currentAccount[0]);
        setIsConnected(true);
        setWalletType('bitget');
      } else {
        throw new Error('No BTC accounts found in Bitget Wallet.');
      }
    } else {
      Toast.error("Bitget Wallet extension not found. Please install it.");
      throw new Error('Bitget Wallet extension not found. Please install it.');
    }
  } catch (error) {
    console.error('Error connecting to Bitget Wallet:', error);
    //setError(error.message || 'An unexpected error occurred.');
  }
};


    const handleConnect = async  (walletType: string) => {
      switch (walletType) {
        case "okx":
          await connectToOkxWallet();
          break;
        case "xverse":
          await connectWallet();
          break;
        case "tomo":
          await connectToTomoWallet();
          break;
        case "bitget":
          await connectToBitgetWallet();
          break;
        default:
          console.error("Unsupported wallet type");
          break;
      }
      closeConnectWalletModal(); // Close the modal after initiating connection
    };



    const closeConnectWalletModal = useCallback(() => {
      ConnectBtcWalletModal.remove();
    }, [ConnectBtcWalletModal]);
  
  return (
    <div className="unstake">
      {/* <form> */}
      <CommonInput
        label="You Unstake"
        labelRight="Balance: 0 SBTC"
        coin={CoinImg}
        coinName="BTC"
        placeholder="0"
        rightBtnTitle="MAX"
      // error={"Enter valid details"}
      />
      <CommonInput
        label="Send to"
        placeholder={formatAddress(paymentAddress)}
        rightBtnTitle={!paymentAddress ? "Connect BTC wallet" : "Disconnect BTC wallet"}
        onClickRightBtn={() => {
          if (paymentAddress) {
            disconnectWallet(walletType)
          } else {
            ConnectBtcWalletModal.show({ closeConnectWalletModal, handleConnect });
          }
        }}
        
      />
        {paymentAddress && <p>Connected BTC Address: {paymentAddress}</p>}

      <ul className="common_listing">
        <li><span>You will receive</span> <div><strong>0 BTC</strong> <img src={BTC} className="me-0" alt="icon" /> <span className="d-block">1 BTC = 1 SBTC</span></div></li>
        <li><span>Network security fee <CommonTooltip
                    popoverTitle="Popover Title"
                    popoverContent="This is the popover content."
                    trigger="click"
                    placement="right"
                    btnIcon={<ExclamationIcon />}
                /> </span> <div><strong>up to $10.49</strong> <span className="d-block">0.000' ETC</span></div></li>
        <li><span>Unstaking period </span> <div><strong>7-9 days</strong></div></li>
      </ul>
      <CommonButton title="Unstake" disabled fluid/>
      {/* </form> */}
    </div>
  )
}
export default Unstake